<template>
  <div class="enrolling-check-student">
    <PlatDataGridSiteUnit grid-id="PeEnrollCheckStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingCheckStudent',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
.enrolling-check-student {
  height: 100%;
}
</style>
